import { createSlice } from "@reduxjs/toolkit";
import { fetchVendorrecommendationsItems } from "./VendorrecommendationsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const vendorrecommendationsSlice = createSlice({
  name: "vendorrecommendations",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchVendorrecommendationsItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorrecommendationsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchVendorrecommendationsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default vendorrecommendationsSlice.reducer;